import { useMemo } from 'react';
import { HourRange, SixtyRange } from 'cron-parser/types';

import { globalTranslation, useTranslation } from 'modules/i18n';

export enum IntervalType {
  Hours = 'HOURS',
  Minutes = 'MINUTES',
}

interface UseIntervalOptionsResult {
  intervalTypeOptions: { id: IntervalType; name: string }[];
  intervalValuesOptions: { id: string; name: string }[];
}

const MINUTE_VALUES: SixtyRange[] = [1, 2, 3, 4, 5, 6, 10, 12, 15, 20, 30];
const HOURS_VALUES: HourRange[] = [1, 2, 3, 4, 6, 8, 12];

export function useIntervalOptions(
  type: IntervalType,
): UseIntervalOptionsResult {
  const { keys, t } = useTranslation(globalTranslation);

  const intervalTypeOptions = useMemo(
    () => [
      { id: IntervalType.Hours, name: t(keys.time.everyXHours) },
      { id: IntervalType.Minutes, name: t(keys.time.everyXMinute) },
    ],
    [keys, t],
  );

  const intervalValuesOptions = useMemo(() => {
    switch (type) {
      case IntervalType.Hours:
        return HOURS_VALUES.map(value => ({
          id: `0 */${value} * * *`,
          name: t(keys.time.everyHour, { value }),
        }));
      case IntervalType.Minutes:
      default:
        return MINUTE_VALUES.map(value => ({
          id: `*/${value} * * * *`,
          name: t(keys.time.everyMinute, { value }),
        }));
    }
  }, [type, keys, t]);

  return {
    intervalTypeOptions,
    intervalValuesOptions,
  };
}
